// // // base44Client.js
// // import { createClient } from '@base44/sdk';

// // export const base44 = createClient({
// //   appId: "69382c65b35506e7d2be018d",
// //   requiresAuth: false   // 👈 לבטל הפניה למסך לוגין של Base44
// // });


// // src/api/base44Client.js
// // ניתקנו את הספרייה החיצונית. כעת זהו אובייקט מקומי בלבד.






// import axios from "axios";

// // הכתובת של השרת המקומי שלך
// const API_BASE = "http://localhost:5001/api"; 

// // יצירת 'שליח' שמדבר עם השרת
// const client = axios.create({
//   baseURL: API_BASE,
//   headers: { "Content-Type": "application/json" }
// });

// // הגדרה חשובה: לפני כל בקשה לשרת, תוסיף את הטוקן של המשתמש
// client.interceptors.request.use((config) => {
//   const token = localStorage.getItem("auth_token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// // המיפוי: כאן אנחנו אומרים למערכת לאן לפנות עבור כל סוג מידע
// export const base44 = {
//   auth: {
//     // פונקציית התנתקות
//     logout: () => {
//       localStorage.removeItem("auth_token");
//       localStorage.removeItem("app_user");
//       window.location.href = "/login";
//     }
//   },
  
//   entities: {
//     // === כאן החיבור האמיתי למשתמשים ===
//     User: {
//       // קבלת כל המשתמשים: GET /api/users
//       list: async () => { 
//         try {
//           const res = await client.get("/users"); 
//           return res.data; 
//         } catch (e) { return []; }
//       },
//       // יצירת משתמש חדש: POST /api/users
//       create: async (data) => { 
//         const res = await client.post("/users", data); 
//         return res.data; 
//       },
//       // עדכון משתמש: PUT /api/users/:id
//       update: async (id, data) => { 
//         const res = await client.put(`/users/${id}`, data); 
//         return res.data; 
//       },
//       // סינון (כרגע נשאיר ריק למניעת תקלות)
//       filter: async () => [] 
//     },


//     UserRole: {
//       list: async () => { 
//         const res = await client.get("/roles"); 
//         return res.data; 
//       },
//       create: async (data) => { 
//         const res = await client.post("/roles", data); 
//         return res.data; 
//       },
//       update: async (id, data) => { 
//         const res = await client.put(`/roles/${id}`, data); 
//         return res.data; 
//       }
//     },



//     // === כל השאר נשארים "דמה" (ריקים) כדי לא לשבור את האתר ===
//     // ברגע שתבנה בשרת את storeController, נחבר גם את זה באותה צורה
//     Store: { list: async () => [] },
//     Chain: { list: async () => [] },
//     Product: { list: async () => [], filter: async () => [] },
//     Category: { list: async () => [] },
//     Company: { list: async () => [] },
//     Supplier: { list: async () => [] },
//     InventoryCount: { list: async () => [], filter: async () => [] },
//     ServiceRequest: { list: async () => [] },
//     Return: { list: async () => [] },
//     Destruction: { list: async () => [] },
//     MustOrderTask: { list: async () => [] },
//     SafeCount: { list: async () => [] },
//     SearchHistory: { filter: async () => [] },
//     Notification: { list: async () => [] },
//     Brochure: { list: async () => [] },
//     Promotion: { list: async () => [] },
//     Order: { list: async () => [] },
//     PromotionImplementation: { list: async () => [] }
//   }
// };







import axios from "axios";

const isDev = import.meta.env.MODE === 'development';
// const API_BASE = isDev 
//   ? "http://localhost:5001" 
//   : "https://api.reshet.app";

const API_BASE =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV ? "/api" : "https://dev.api.reshet.app/api");




const client = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 60000
});

function getActingStoreIdFromUrl() {
  try {
    if (typeof window === "undefined") return "";
    return new URLSearchParams(window.location.search).get("storeId")?.trim() || "";
  } catch (_) {
    return "";
  }
}

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  try {
    const actingStoreId = getActingStoreIdFromUrl();
    if (actingStoreId) {
      config.headers["X-Acting-Store-Id"] = actingStoreId;
    }
  } catch (_) {}
  return config;
}, (error) => {
  return Promise.reject(error);
});

// פונקציית עזר למניעת קריסות למודולים שעוד לא בנינו
const emptyMock = {
  list: async () => [],
  get: async () => ({}),
  filter: async () => [],
  create: async () => ({}),
  update: async () => ({}),
  delete: async () => ({})
};


// פונקציית עזר לקיצור קוד (יוצרת אוטומטית list, get, create, update, delete)
const createCrudEndpoints = (endpoint) => ({
  list: async (params = {}) => {
    try {
      const res = await client.get(endpoint, { params });
      return res.data;
    } catch (e) { return []; }
  },
  get: async (id) => {
    const res = await client.get(`${endpoint}/${id}`);
    return res.data;
  },
  create: async (data) => {
    const res = await client.post(endpoint, data);
    return res.data;
  },
  update: async (id, data) => {
    const res = await client.put(`${endpoint}/${id}`, data);
    return res.data;
  },
  delete: async (id) => {
    const res = await client.delete(`${endpoint}/${id}`);
    return res.data;
  }
});


export const base44 = {
  auth: {
    me: async () => {
      const res = await client.get("/auth/me");
      return res.data;
    },
    /** קוד SMS לאזור נתונים קריטיים (משתמש מחובר + הרשאה בפרופיל) */
    requestCriticalDataSms: async () => {
      const res = await client.post("/auth/critical-data/request-sms");
      return res.data;
    },
    verifyCriticalDataSms: async (code) => {
      const res = await client.post("/auth/critical-data/verify", { code });
      return res.data;
    },
    logout: () => {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("app_user");
      if (typeof navigator !== "undefined" && navigator.onLine) {
        window.location.href = "/login";
      }
    }
  },
  
  // אינטגרציות (למשל העלאת קבצים)
  integrations: {
    Core: {
       // אם עדיין אין לך ראוט להעלאת קבצים כללית, נשתמש בזה של ה-Chains או ניצור חדש
       // כרגע אני משתמש בנתיב כללי, אם אין לך אותו תגיד לי וניצור
       UploadFile: async ({ file, folder = 'logos' }) => {
        const formData = new FormData();
        
        // חשוב מאוד: הוספת ה-folder לפני ה-file!
        formData.append("folder", folder); 
        formData.append("file", file);
      
        const res = await client.post("/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 180000,
        });
        return res.data;
      }
    }
  },

  push: {
    getVapidPublicKey: async () => {
      const res = await client.get("/push/vapid-public-key");
      return res.data;
    },
    getStatus: async () => {
      const res = await client.get("/push/status");
      return res.data;
    },
    subscribe: async (subscription) => {
      const res = await client.post("/push/subscribe", { subscription });
      return res.data;
    },
    unsubscribe: async (endpoint) => {
      const res = await client.post("/push/unsubscribe", { endpoint });
      return res.data;
    },
    send: async (data) => {
      const res = await client.post("/push/send", data);
      return res.data;
    },
  },

  notificationTypes: {
    list: async () => {
      const res = await client.get("/notification-types");
      return res.data;
    },
    init: async () => {
      const res = await client.post("/notification-types/init");
      return res.data;
    },
    create: async (data) => {
      const res = await client.post("/notification-types", data);
      return res.data;
    },
    update: async (key, data) => {
      const res = await client.put(`/notification-types/${key}`, data);
      return res.data;
    },
    delete: async (key) => {
      const res = await client.delete(`/notification-types/${key}`);
      return res.data;
    },
  },

  areaManager: {
    listStores: async () => {
      const res = await client.get("/area-manager/stores");
      return res.data;
    },
    getActingStore: async (storeId) => {
      const res = await client.get(`/area-manager/stores/${storeId}`);
      return res.data;
    },
  },

  presence: {
    ping: async (data = {}) => {
      const res = await client.post("/presence/ping", data);
      return res.data;
    },
  },

  adminMonitoring: {
    live: async () => {
      const res = await client.get("/admin-monitoring/live");
      return res.data;
    },
  },

  keshetHeroes: {
    getDesk: async (params = {}) => {
      const res = await client.get("/keshet-heroes/desk", { params });
      return res.data;
    },
    getCustomerAnalysis: async (id, params = {}) => {
      const res = await client.get(`/keshet-heroes/customers/${encodeURIComponent(id)}/analysis`, { params });
      return res.data;
    },
    listCustomers: async (params = {}) => {
      const res = await client.get("/keshet-heroes/customers", { params });
      return res.data;
    },
    syncCustomers: async () => {
      const res = await client.post("/keshet-heroes/customers/sync", {}, { timeout: 180000 });
      return res.data;
    },
    listOrders: async (params = {}) => {
      const res = await client.get("/keshet-heroes/orders", { params });
      return res.data;
    },
    getOrder: async (id) => {
      const res = await client.get(`/keshet-heroes/orders/${id}`);
      return res.data;
    },
    syncOrders: async (body = {}) => {
      const res = await client.post("/keshet-heroes/orders/sync", body, { timeout: 600000 });
      return res.data;
    },
  },

  storeComaxCatalog: {
    getStoresSummary: async () => {
      const res = await client.get("/store-comax-catalog/stores-summary");
      return res.data;
    },
    getFacets: async (params = {}) => {
      const res = await client.get("/store-comax-catalog/facets", { params, timeout: 120000 });
      return res.data;
    },
    listItems: async (params = {}) => {
      const res = await client.get("/store-comax-catalog/items", { params, timeout: 60000 });
      return res.data;
    },
    sync: async (body = {}) => {
      const res = await client.post("/store-comax-catalog/sync", body, { timeout: 600000 });
      return res.data;
    },
    syncAsync: async (body = {}) => {
      const res = await client.post("/store-comax-catalog/sync", { ...body, async: true });
      return res.data;
    },
    stockGroups: {
      coverage: async () => {
        const res = await client.get("/store-comax-catalog/stock-groups/coverage");
        return res.data;
      },
      syncBrands: async () => {
        const res = await client.post("/store-comax-catalog/stock-groups/sync-brands");
        return res.data;
      },
      listBrands: async () => {
        const res = await client.get("/store-comax-catalog/stock-groups/brands");
        return res.data;
      },
      createBrand: async (body) => {
        const res = await client.post("/store-comax-catalog/stock-groups/brands", body);
        return res.data;
      },
      listGroups: async (params = {}) => {
        const res = await client.get("/store-comax-catalog/stock-groups/groups", { params });
        return res.data;
      },
      searchCatalog: async (q) => {
        const res = await client.get("/store-comax-catalog/stock-groups/catalog-search", {
          params: { q },
        });
        return res.data;
      },
      createGroup: async (body) => {
        const res = await client.post("/store-comax-catalog/stock-groups/groups", body);
        return res.data;
      },
      renameGroup: async (id, body) => {
        const res = await client.patch(`/store-comax-catalog/stock-groups/groups/${id}`, body);
        return res.data;
      },
      deleteGroup: async (id) => {
        const res = await client.delete(`/store-comax-catalog/stock-groups/groups/${id}`);
        return res.data;
      },
      view: async (params = {}) => {
        const res = await client.get("/store-comax-catalog/stock-groups/view", {
          params,
          timeout: 60000,
        });
        return res.data;
      },
      members: async (id, params = {}) => {
        const res = await client.get(`/store-comax-catalog/stock-groups/groups/${id}/members`, {
          params,
          timeout: 60000,
        });
        return res.data;
      },
      assign: async (id, body) => {
        const res = await client.post(`/store-comax-catalog/stock-groups/groups/${id}/assign`, body);
        return res.data;
      },
      assignToBrand: async (brandId, body) => {
        const res = await client.post(
          `/store-comax-catalog/stock-groups/brands/${brandId}/assign`,
          body
        );
        return res.data;
      },
      moveMembers: async (id, body) => {
        const res = await client.post(
          `/store-comax-catalog/stock-groups/groups/${id}/move-members`,
          body
        );
        return res.data;
      },
      removeMembers: async (body) => {
        const res = await client.post("/store-comax-catalog/stock-groups/members/remove", body);
        return res.data;
      },
      unassigned: async (params = {}) => {
        const res = await client.get("/store-comax-catalog/stock-groups/unassigned", {
          params,
          timeout: 180000,
        });
        return res.data;
      },
      suggestions: async (params = {}) => {
        const res = await client.get("/store-comax-catalog/stock-groups/suggestions", {
          params,
          timeout: 120000,
        });
        return res.data;
      },
      promoRewardImportStats: async () => {
        const res = await client.get("/store-comax-catalog/stock-groups/promo-reward-import");
        return res.data;
      },
      importPromoRewardReport: async (file) => {
        const form = new FormData();
        form.append("file", file);
        const res = await client.post("/store-comax-catalog/stock-groups/promo-reward-import", form, {
          timeout: 180000,
          headers: { "Content-Type": undefined },
        });
        return res.data;
      },
      approvePromoRewardFamilies: async (file) => {
        const form = new FormData();
        if (file) form.append("file", file);
        const res = await client.post("/store-comax-catalog/stock-groups/promo-reward-approve", form, {
          timeout: 180000,
          headers: { "Content-Type": undefined },
        });
        return res.data;
      },
    },
  },

  entities: {
    // משתמשים ותפקידים
    User: {
      list: async () => { try { const res = await client.get("/users"); return res.data; } catch (e) { return []; } },
      create: async (data) => { const res = await client.post("/users", data); return res.data; },
      update: async (id, data) => { const res = await client.put(`/users/${id}`, data); return res.data; },
      archive: async (id, body) => {
        const res = await client.post(`/users/${id}/archive`, body);
        return res.data;
      },
      filter: async () => [] 
    },
    UserRole: {
      list: async () => { try { const res = await client.get("/roles"); return res.data; } catch (e) { return []; } },
      create: async (data) => { const res = await client.post("/roles", data); return res.data; },
      update: async (id, data) => { const res = await client.put(`/roles/${id}`, data); return res.data; }
    },

    // רשתות
    Chain: {
      list: async () => { try { const res = await client.get("/chains"); return res.data; } catch (e) { return []; } },
      create: async (data) => { 
        const res = await client.post("/chains", data, { headers: { "Content-Type": "multipart/form-data" } }); 
        return res.data; 
      },
      update: async (id, data) => { 
        const res = await client.put(`/chains/${id}`, data, { headers: { "Content-Type": "multipart/form-data" } }); 
        return res.data; 
      },
      filter: async () => []
    },

    // חנויות
    Store: {
      list: async () => { try { const res = await client.get("/stores"); return res.data; } catch (e) { return []; } },
      get: async (id) => { const res = await client.get(`/stores/${id}`); return res.data; },
      create: async (data) => { const res = await client.post("/stores", data); return res.data; },
      update: async (id, data) => { const res = await client.put(`/stores/${id}`, data); return res.data; },
      delete: async (id) => { const res = await client.delete(`/stores/${id}`); return res.data; },
      filter: async ({ id }) => { 
          // תמיכה ב-filter שהשתמשנו בו ב-StoreDetails
          if(id) {
             const res = await client.get(`/stores/${id}`);
             return [res.data];
          }
          return [];
      },
      listBranches: async (storeId) => {
        const res = await client.get(`/stores/${storeId}/branches`);
        return res.data;
      },
      createBranch: async (storeId, data) => {
        const res = await client.post(`/stores/${storeId}/branches`, data);
        return res.data;
      },
      updateBranch: async (storeId, branchId, data) => {
        const res = await client.put(`/stores/${storeId}/branches/${branchId}`, data);
        return res.data;
      },
      deleteBranch: async (storeId, branchId) => {
        const res = await client.delete(`/stores/${storeId}/branches/${branchId}`);
        return res.data;
      },
    },

    // --- התיקון: חיבור ספקים (Suppliers) ---
    Supplier: {
      list: async () => { try { const res = await client.get("/suppliers"); return res.data; } catch (e) { return []; } },
      get: async (id) => { const res = await client.get(`/suppliers/${id}`); return res.data; },
      
      // FormData – חובה לבטל את application/json, אחרת axios הופך את הקובץ לטקסט והלוגו לא נשמר
      create: async (data) => {
          const res = await client.post("/suppliers", data, {
            headers: data instanceof FormData ? { "Content-Type": undefined } : undefined,
          });
          return res.data;
      },
      update: async (id, data) => {
          const res = await client.put(`/suppliers/${id}`, data, {
            headers: data instanceof FormData ? { "Content-Type": undefined } : undefined,
          });
          return res.data;
      },

      getDeliveryInfo: async (id) => {
        const res = await client.get(`/suppliers/my-delivery-info/${id}`);
        return res.data;
      },
      
      delete: async (id) => { const res = await client.delete(`/suppliers/${id}`); return res.data; },
    },
    
    // הגדרות מערכת
    SystemSetting: {
        list: async () => { try { const res = await client.get("/settings"); return res.data; } catch (e) { return []; } },
        update: async (key, values) => { const res = await client.put(`/settings/${key}`, { values }); return res.data; },
        init: async () => { await client.post("/settings/init"); },
        /** תצוגת תוויות כשר לפסח / נאפה אחרי פסח — לכל משתמש מחובר */
        getUiLabels: async () => {
          const res = await client.get("/settings/ui-labels");
          return res.data;
        },
        getPromotedCompanies: async () => {
          const res = await client.get("/settings/promoted-companies");
          return res.data;
        },
    },


    ServiceRequest: {
      list: async () => { 
          try {
              const res = await client.get("/service-requests"); 
              return res.data; 
          } catch (e) { return []; } 
      },
      get: async (id) => {
          const res = await client.get(`/service-requests/${id}`);
          return res.data;
      },
      meta: async () => {
          const res = await client.get("/service-requests/meta");
          return res.data;
      },
      alertRecipients: async () => {
          const res = await client.get("/service-requests/alert-recipients");
          return res.data;
      },
      saveAlertRecipients: async (userIds) => {
          const res = await client.put("/service-requests/alert-recipients", { userIds });
          return res.data;
      },
      create: async (data) => { 
          const res = await client.post("/service-requests", data); 
          return res.data; 
      },
      update: async (id, data) => { 
          const res = await client.patch(`/service-requests/${id}`, data); 
          return res.data; 
      },
      delete: async (id) => { 
          const res = await client.delete(`/service-requests/${id}`); 
          return res.data; 
      }
  },

  ManagementTask: {
    list: async (sort = '-created_date') => {
      const res = await client.get("/management-tasks", { params: { sort } });
      return res.data;
    },
    filter: async (params) => {
      const res = await client.get("/management-tasks", { params });
      return res.data;
    },
    create: async (data) => {
      const res = await client.post("/management-tasks", data);
      return res.data;
    },
    get: async (id) => {
      const res = await client.get(`/management-tasks/${id}`);
      return res.data;
    },
    // פונקציה להשלמת משימה על ידי סניף
    complete: async (id, data) => {
      const res = await client.patch(`/management-tasks/${id}/complete`, data);
      return res.data;
    }
  },


  // בתוך entities בתוך base44Client.js
Order: {
  /** מיון לשרת — מחרוזת או { sort: '-createdAt' } (לא אובייקט store_id; הסינון הוא לפי JWT בשרת) */
  list: async (sortOrParams = "-createdAt") => {
    const params =
      typeof sortOrParams === "string"
        ? { sort: sortOrParams }
        : { ...(sortOrParams || {}) };
    if (!params.sort) params.sort = "-createdAt";
    const timeout = Number(params.timeout) || 0;
    const throwOnError = !!params.throwOnError;
    delete params.timeout;
    delete params.throwOnError;
    try {
      const res = await client.get("/orders", {
        params,
        ...(timeout > 0 ? { timeout } : { timeout: 45000 }),
      });
      return res.data;
    } catch (e) {
      console.error("Error fetching orders:", e);
      if (throwOnError) throw e;
      return [];
    }
  },
  get: async (id) => {
    const res = await client.get(`/orders/${id}`);
    return res.data;
  },
  stats: async () => {
    const res = await client.get("/orders", { params: { view: "stats" } });
    return res.data;
  },
  /** timeout ברירת מחדל ארוך — שליחה לקומקס יכולה לקחת דקות; BasicProductsReminder מעביר { timeout: 0 } ללא הגבלה */
  create: async (data, axiosConfig = {}) => {
    const res = await client.post("/orders", data, {
      timeout: 180000,
      ...axiosConfig,
    });
    return res.data;
  },
  update: async (id, data) => {
    const res = await client.put(`/orders/${id}`, data);
    return res.data;
  },
  warehousePrint: async (id) => {
    // הוספת timeout ספציפי של 30 שניות לקריאה הזו
    const res = await client.post(`/orders/${id}/reprint-warehouse`, {}, { timeout: 30000 });
    return res.data;
  },
  printDetails: async (id) => {
    const res = await client.post(`/orders/${id}/print-details`, {}, { timeout: 30000 });
    return res.data;
  },
  /** ארכיון (מחיקה רכה) – סופר אדמין + אימות מספר הזמנה */
  archive: async (id, body) => {
    const res = await client.post(`/orders/${id}/archive`, body);
    return res.data;
  },
  /** תאריך הזמנה אחרונה לסניף שבטוקן (אופציונלי storeId לאדמין) */
  getLastProductPurchase: async (params) => {
    const res = await client.get("/orders/last-product-purchase", { params });
    return res.data;
  },
  getLastProductPurchasesBatch: async (params) => {
    const res = await client.get("/orders/last-product-purchases", { params });
    return res.data;
  },
  getLastPurchasesForStore: async (params) => {
    const res = await client.get("/orders/last-purchases-for-store", { params });
    return res.data;
  },
  getOrderedProductIds: async (params) => {
    const res = await client.get("/orders/ordered-product-ids", { params });
    return res.data;
  },
  // פונקציית פילטר כדי למנוע שגיאות בחיפושים מסוימים
  filter: async ({ id }) => {
    if (id) {
      const res = await client.get(`/orders/${id}`);
      return [res.data];
    }
    return [];
  }
},


  Brochure: {
    list: async (params = {}) => {
      try {
        const res = await client.get("/brochures", { params });
        return res.data;
      } catch (e) {
        return [];
      }
    },
    create: async (data) => { const res = await client.post("/brochures", data); return res.data; },
    update: async (id, data) => { const res = await client.put(`/brochures/${id}`, data); return res.data; },
    delete: async (id) => { const res = await client.delete(`/brochures/${id}`); return res.data; }
},
DailySale: {
  getProductStats: async (params) => {
    const res = await client.get("/sales/product-stats", { params });
    return res.data;
  },
  getStoreProductStats: async (params = {}) => {
    const res = await client.get("/sales/store-product-stats", { params, timeout: 120000 });
    return res.data;
  },
  getAnalyticsDashboard: async (params) => {
    const res = await client.get("/sales/analytics/dashboard", { params });
    return res.data;
  },
  getAnalyticsProducts: async (params) => {
    const res = await client.get("/sales/analytics/products", { params });
    return res.data;
  },
  getCatalogStockSales: async (params) => {
    const res = await client.get("/sales/catalog-stock", { params, timeout: 90000 });
    return res.data;
  },
  getDayDetail: async (params) => {
    const res = await client.get("/sales/analytics/day-detail", { params });
    return res.data;
  },
  getPeriodComparison: async (params) => {
    const scope = params?.scope || "core";
    const timeout =
      params?.fullProducts || scope === "full"
        ? 180000
        : scope === "products" || scope === "details"
          ? 120000
          : scope === "departments"
            ? 120000
          : scope === "department-products"
            ? 60000
          : scope === "bootstrap" || scope === "core"
            ? 45000
            : 45000;
    const res = await client.get("/sales/analytics/period-comparison", {
      params,
      timeout,
    });
    return res.data;
  },
},
// התראות - מחובר לשרת!
Notification: {
    list: async () => { try { const res = await client.get("/notifications"); return res.data; } catch (e) { return []; } },
    create: async (data) => { const res = await client.post("/notifications", data); return res.data; },
    update: async (id, data) => { 
      const res = await client.put(`/notifications/${id}`, data); 
      return res.data; 
  },
    acknowledge: async (id, data = {}) => {
      const res = await client.post(`/notifications/${id}/ack`, data);
      return res.data;
    },
    sentCampaigns: async () => {
      const res = await client.get("/notifications/campaigns");
      return res.data;
    },
},

SystemUpdate: {
    list: async () => {
      const res = await client.get("/system-updates");
      return res.data;
    },
    get: async (id) => {
      const res = await client.get(`/system-updates/${id}`);
      return res.data;
    },
    feed: async () => {
      const res = await client.get("/system-updates/feed");
      return res.data;
    },
    create: async (data) => {
      const res = await client.post("/system-updates", data);
      return res.data;
    },
    update: async (id, data) => {
      const res = await client.put(`/system-updates/${id}`, data);
      return res.data;
    },
    remove: async (id) => {
      const res = await client.delete(`/system-updates/${id}`);
      return res.data;
    },
    markViewed: async (id) => {
      const res = await client.post(`/system-updates/${id}/view`);
      return res.data;
    },
},

Promotion: {
  ...createCrudEndpoints("/promotions"),
  bulkImport: async (promotions) =>
    client.post("/promotions/import", { promotions }, { timeout: 300000 }),
  previewComax: async (data = {}) => {
    const res = await client.post("/promotions/comax-preview", data, { timeout: 180000 });
    return res.data;
  },
  importComax: async (data) => {
    const res = await client.post("/promotions/comax-import", data, { timeout: 180000 });
    return res.data;
  },

  list: async () => {
    try {
      const res = await client.get("/promotions", { timeout: 120000 });
      return Array.isArray(res.data) ? res.data : []; // מבטיח שתמיד יחזור מערך
    } catch (e) {
      return [];
    }
  },
  orderQuantities: async () => {
    const res = await client.get("/promotions/order-quantities", { timeout: 120000 });
    return res.data || {};
  },
  dashboardStats: async () => {
    const res = await client.get("/promotions/dashboard-stats", { timeout: 60000 });
    return res.data || {};
  },
  currentByProduct: async () => {
    try {
      const res = await client.get("/promotions/current-by-product", { timeout: 120000 });
      return res.data || {};
    } catch (e) {
      console.error("Error fetching current promotions by product:", e);
      return {};
    }
  },
  listAdminPage: async (params = {}) => {
    const res = await client.get("/promotions/admin", { params, timeout: 60000 });
    return res.data;
  },
  listAdminIds: async (params = {}) => {
    const res = await client.get("/promotions/admin/ids", { params, timeout: 120000 });
    return res.data;
  },
  adminStats: async () => {
    const res = await client.get("/promotions/admin/stats", { timeout: 30000 });
    return res.data;
  },
  deleteExpired: async () => {
    const res = await client.delete("/promotions/expired", { timeout: 120000 });
    return res.data;
  },
  filter: async () => {
    try {
      const res = await client.get("/promotions");
      return Array.isArray(res.data) ? res.data : [];
    } catch (e) {
      return [];
    }
  },
  create: (data) => client.post("/promotions", data),
  update: (id, data) => client.put(`/promotions/${id}`, data),
  bulkUpdate: async (data) => {
    const res = await client.put("/promotions/bulk-update", data);
    return res.data;
  },
  cancelSend: async (data) => {
    const res = await client.post("/promotions/cancel-send", data, { timeout: 300000 });
    return res.data;
  },
  bulkDelete: async (data) => {
    const res = await client.post("/promotions/bulk-delete", data, { timeout: 300000 });
    return res.data;
  },
  delete: (id) => client.delete(`/promotions/${id}`),

  // ✅ חדש
  send: async (data) => {
    const res = await client.post("/promotions/send", data);
    return res.data;
  },
  sendToStores: async (body) => {
    const res = await client.post("/promotions/send-to-stores", body, { timeout: 300000 });
    return res.data;
  },
  import: async (data) => {
    // הוספת timeout של 60 שניות לקריאה הזו
    const res = await client.post("/promotions/import", data, { timeout: 60000 });
    return res.data;
},
},



// ✅ תיקון קריטי: העברת הפרמטרים (params) לשרת
Product: {
  list: async (params = {}) => { 
      try {
        // אנחנו מעבירים את ה-params (עמוד, פילטרים וכו') לתוך בקשת ה-GET
        const res = await client.get("/products", { params }); 
        return res.data; 
      } catch (e) { return { data: [], pagination: { total: 0 } }; }
  },
  get: async (id, params = {}) => {
      const res = await client.get(`/products/${id}`, { params });
      return res.data;
  },
  getSharedBarcodeSiblings: async (barcode) => {
    const res = await client.get("/products/shared-barcode", { params: { barcode } });
    return res.data;
  },
  // listForMyStore: async (params = {}) => {
  //   try {
  //     const res = await client.get("/products/store", { params });
  //     return res.data;
  //   } catch (e) {
  //     return { data: [], pagination: { page: 1, pages: 1, total: 0 } };
  //   }
  // },

  listForMyStore: async (params = {}) => {
    const isPrefetch =
      params.prefetch === 1 ||
      params.prefetch === "1" ||
      params.prefetch === true;
    const res = await client.get("/products/store", {
      params,
      timeout: isPrefetch ? 120000 : undefined,
    });
    return res.data;
  },
  searchForReturns: async (params = {}) => {
    try {
      const res = await client.get("/products/search-for-returns", { params });
      return res.data;
    } catch (e) {
      return { data: [] };
    }
  },
  getByCategory: async (categoryId) => {
    const res = await client.get(`/products/by-category/${categoryId}`);
    return res.data; // מחזיר מערך פשוט של מוצרים
  },
  update: async (id, data) => { 
      const res = await client.put(`/products/${id}`, data); 
      return res.data; 
  },
  delete: async (id) => { 
      const res = await client.delete(`/products/${id}`); 
      return res.data; 
  },
  sync: async () => {
    const res = await client.post("/products/sync", {}, {
      // ✅ המתנה של עד 10 דקות לפני שמוותרים על התשובה
      timeout: 600000 
  });
      return res.data;
  },
  /** @deprecated בפועל מפעיל GS1; השתמש ב-syncImagesFromDriveOnly לדרייב */
  syncImages: async () => {
    const res = await client.post("/images/sync-drive");
    return res.data;
  },
  /** תמונות מ-Google Drive בלבד (סריקה רקורסיבית, WebP ל-S3, רק מוצרים ללא תמונה) */
  syncImagesFromDriveOnly: async () => {
    const res = await client.post("/images/sync-from-drive", {}, { timeout: 600000 });
    return res.data;
  },
  /** תמונות מ-GS1 בלבד (רק מוצרים ללא תמונה — אותה שאילתה כמו דרייב) */
  syncImagesFromGS1Only: async () => {
    const res = await client.post("/images/sync-from-gs1", {}, { timeout: 600000 });
    return res.data;
  },
  syncImagesFull: async () => {
    const res = await client.post("/images/sync-full", {}, { timeout: 600000 });
    return res.data;
  },
  getDriveImageSyncStatus: async () => {
    const res = await client.get("/images/drive-sync-status");
    return res.data;
  },
  runDriveImageSyncScheduled: async (body = {}) => {
    const res = await client.post("/images/drive-sync-run", body, { timeout: 600000 });
    return res.data;
  },
getRelated: async (params) => {
  const res = await client.get("/products/related", { params });
  return res.data;
},
/** המוצרים הבאים בסדר באותה תת־תת־קטגוריה (מעגלית) */
getNextInSubSub: async (params) => {
  const res = await client.get("/products/next-in-subsub", { params });
  return Array.isArray(res.data) ? res.data : [];
},
searchInStore: async (params = {}) => {
  try {
    const res = await client.get("/products/search/my-store", { params });
    return res.data;
  } catch (e) {
    return { data: [], pagination: { total: 0 } };
  }
},
export: async (params = {}) => {
  // responseType: 'blob' הכרחי כדי שהדפדפן יזהה שזה קובץ להורדה
  const res = await client.get("/products/export", { params, responseType: 'blob' });
  return res;
},
bulkUpdate: async (filters, updateData) => {
  const res = await client.post("/products/bulk-update", { filters, updateData });
  return res.data;
},
/** סדר מוצרים לפי חברה או תת־תת־קטגוריה — בקשה אחת (bulkWrite בשרת) */
reorderDisplayOrder: async ({ kind, scopeId, orderedProductIds }) => {
  const res = await client.post(
    "/products/reorder-display-order",
    { kind, scopeId, orderedProductIds },
    { timeout: 120000 }
  );
  return res.data;
},
  filter: async () => [] 
},

Recommendation: {
  listSuppliers: async () => {
    try {
      const res = await client.get("/recommendations/suppliers");
      return res.data;
    } catch (e) {
      return [];
    }
  },
  getAdminStoresSummary: async (params) => {
    const res = await client.get("/recommendations/admin/stores-summary", {
      params,
      timeout: 300000,
    });
    const body = res.data;
    return body?.data ?? body;
  },
  getAdminStoreDetail: async (storeId, params) => {
    const res = await client.get(`/recommendations/admin/store/${storeId}`, {
      params,
      timeout: 180000,
    });
    const body = res.data;
    return body?.data ?? body;
  },
  getAdminRecommendationRuns: async (params) => {
    const res = await client.get("/recommendations/admin/runs", { params });
    const body = res.data;
    const inner = body?.data ?? body;
    return inner?.runs != null ? inner : { runs: [] };
  },
  getAdminHolidayContext: async () => {
    const res = await client.get("/recommendations/admin/holiday-context");
    const body = res.data;
    return body?.data ?? body;
  },
},


Category: createCrudEndpoints("/categories"),
SubCategory: createCrudEndpoints("/subcategories"),
SubSubCategory: createCrudEndpoints("/subsubcategories"),
Company: createCrudEndpoints("/companies"),



    Return: {
      list: async (sort = "-created_date") => {
        try {
          const actingStoreId = getActingStoreIdFromUrl();
          const res = await client.get("/returns", {
            params: {
              sort: typeof sort === "string" ? sort : "-created_date",
              ...(actingStoreId ? { storeId: actingStoreId } : {}),
            },
          });
          return res.data;
        } catch (e) {
          return [];
        }
      },
      get: async (id) => {
        const res = await client.get(`/returns/${id}`);
        return res.data;
      },
      create: async (data) => {
        const res = await client.post("/returns", data);
        return res.data;
      },
      update: async (id, data) => {
        const res = await client.put(`/returns/${id}`, data);
        return res.data;
      },
      delete: async (id) => {
        const res = await client.delete(`/returns/${id}`);
        return res.data;
      },
      syncPdf: async (id) => {
        const res = await client.post(`/returns/${id}/sync-pdf`);
        return res.data;
      },
      warehousePrint: async (id) => {
        const res = await client.post(`/returns/${id}/print-warehouse`, {}, { timeout: 60000 });
        return res.data;
      },
    },
    Destruction: emptyMock,
    // Promotion: emptyMock,
    // Brochure: emptyMock,
    InventoryCount: emptyMock,
    // Notification: emptyMock,

    
    CartItem: {
      getAdminAllData: async () => {
        try {
          const res = await client.get("/cart/admin-all-data", { timeout: 45000 });
          return res.data;
        } catch (e) {
          console.error("Error fetching admin data:", e);
          return { cartItems: [], stores: [], chains: [], products: [], suppliers: [], cartSummary: [] };
        }
      },
      filter: async (params = {}) => {
        const res = await client.get("/cart", { params });
        return res.data;
      },
      create: async (data) => {
        const res = await client.post("/cart", data);
        return res.data;
      },
      list: async (params = {}) => {
        const res = await client.get("/cart", { params });
        return res.data;
      },
      update: async (data) => {
        const res = await client.post("/cart", data); 
        return res.data;
      },
      getAdminSummary: async () => {
        const res = await client.get("/cart/admin-all-data", {
          params: { summary: 1 },
          timeout: 60000,
        });
        return res.data;
      },
      duplicateOrder: async (data) => {
        const res = await client.post("/cart/duplicate", data); 
        return res.data;
      },
      delete: async (id, meta = {}) => {
        const params = {};
        if (meta?.reason) params.reason = meta.reason;
        if (meta?.client_source) params.client_source = meta.client_source;
        const res = await client.delete(`/cart/${id}`, { params });
        return res.data;
      },
      clearAll: async (store_id, branch_id = "") => {
        const params = { store_id };
        if (branch_id) params.branch_id = branch_id;
        const res = await client.delete('/cart', { params });
        return res.data;
      }
    },


    PromotionImplementation: {
      list: async () => {
        const res = await client.get("/implementations");
        return res.data;
      },
      create: async (data) => {
        const res = await client.post("/implementations", data);
        return res.data;
      },
      update: async (id, data) => {
        const res = await client.patch(`/implementations/${id}`, data);
        return res.data;
      },
      approve: async (id) => {
        const res = await client.patch(`/implementations/${id}/approve`);
        return res.data;
      },
      delete: async (id) => {
        const res = await client.delete(`/implementations/${id}`);
        return res.data;
      },
    },

    // בתוך base44Client.js תחת entities:

MustOrderTask: {
  list: async () => { 
    try {
      const res = await client.get("/must-order-tasks"); 
      return res.data; 
    } catch (e) { return []; }
  },
  filter: async (params) => {
    try {
      const res = await client.get("/must-order-tasks", { params });
      return res.data;
    } catch (e) { return []; }
  },
  create: async (data) => { 
    const res = await client.post("/must-order-tasks", data); 
    return res.data; 
  },
  update: async (id, data) => { 
    const res = await client.put(`/must-order-tasks/${id}`, data); 
    return res.data; 
  },
  delete: async (id) => { 
    const res = await client.delete(`/must-order-tasks/${id}`); 
    return res.data; 
  }
},

ScannedInvoice: {
  parse: async (formData) => {
    const res = await client.post("/scanned-invoices/parse", formData, {
      timeout: 120000,
      headers: { "Content-Type": undefined },
    });
    return res.data;
  },
  getParseJob: async (jobId) => {
    const res = await client.get(`/scanned-invoices/parse-jobs/${jobId}`);
    return res.data;
  },
  create: async (formData) => {
    const res = await client.post("/scanned-invoices", formData, {
      timeout: 120000,
      headers: { "Content-Type": undefined },
    });
    return res.data;
  },
  list: async (params = {}) => {
    const res = await client.get("/scanned-invoices", { params });
    return res.data;
  },
  get: async (id) => {
    const res = await client.get(`/scanned-invoices/${id}`);
    return res.data;
  },
  storesSummary: async () => {
    const res = await client.get("/scanned-invoices/stores-summary");
    return res.data;
  },
  dailyTracking: async (params = {}) => {
    const res = await client.get("/scanned-invoices/daily-tracking", { params });
    return res.data;
  },
},

Distribution: {
  createManual: async (payload) => {
    const res = await client.post("/distributions/manual", payload, { timeout: 60000 });
    return res.data;
  },
  preview: async (formData) => {
    const res = await client.post("/distributions/preview", formData, {
      timeout: 120000,
      headers: { "Content-Type": undefined },
    });
    return res.data;
  },
  execute: async (id) => {
    const res = await client.post(`/distributions/${id}/execute`, {}, { timeout: 60000 });
    return res.data;
  },
  list: async (params = {}) => {
    const res = await client.get("/distributions", { params });
    return res.data;
  },
  get: async (id) => {
    const res = await client.get(`/distributions/${id}`);
    return res.data;
  },
},

// בנוסף, וודא שגם Order מחובר לשרת:
// Order: createCrudEndpoints("/orders"),    
SearchHistory: emptyMock,
    SafeCount: {
      list: async (params = {}) => {
        const res = await client.get("/safe-counts", { params });
        return res.data;
      },
      filter: async (params = {}) => {
        const res = await client.get("/safe-counts", { params });
        return res.data;
      },
      definitions: async () => {
        const res = await client.get("/safe-counts/definitions");
        return res.data;
      },
      create: async (data) => {
        const res = await client.post("/safe-counts", data, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 60000,
        });
        return res.data;
      },
      update: async (id, data) => {
        const res = await client.put(`/safe-counts/${id}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 60000,
        });
        return res.data;
      },
    },
    
    
  },

  diagnostics: {
    listSessions: async () => {
      const res = await client.get("/diagnostics/sessions");
      return res.data;
    },
    getSession: async (id) => {
      const res = await client.get(`/diagnostics/sessions/${id}`);
      return res.data;
    },
    createSession: async (data) => {
      const res = await client.post("/diagnostics/sessions", data);
      return res.data;
    },
    deleteSession: async (id) => {
      const res = await client.delete(`/diagnostics/sessions/${id}`);
      return res.data;
    },
  },

  functions: {
    sendReturn: async ({ returnId, notes } = {}) => {
      const body = notes !== undefined ? { notes } : {};
      const res = await client.post(`/returns/${returnId}/send`, body, { timeout: 180000 });
      return { data: res.data };
    },
    sendDestruction: async () => ({ data: {} }),
    createDailyInventory: async () => ({ data: {} }),
  },

  syncLogs: {
    getOverview: async () => {
      const res = await client.get("/sync-logs/overview");
      return res.data;
    },
    listRuns: async (params = {}) => {
      const res = await client.get("/sync-logs", { params });
      return res.data;
    },
    getRun: async (id) => {
      const res = await client.get(`/sync-logs/${id}`);
      return res.data;
    },
  },
};